import React, { useEffect, useState, useCallback, useContext } from "react";
import { Map, APIProvider, Marker } from "@vis.gl/react-google-maps";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { makeStyles } from "@material-ui/core/styles";
import GoogleMapAutoComplete from "./Map/GoogleAutoComplete-custom";
import { toast } from "@/helpers/toast";
import { LanguageContext } from "@/langs/LanguageContext";
import PlatFormLoading from "@/components/loading"; // 公共进度条
import { APP_ENV } from "@/APP_ENV";

const useModalStyles = makeStyles(theme => ({
  StoreEditMapModal: {},
  mapSearchInput: {
    padding: "5px 0 12px"
  },
  StoreEditMapBox: {
    width: "100%",
    height: "100%",
    "& .platformMap": {
      height: 460
    },
    "& .map-detail": {
      background: "#F8F9FC",
      "border-radius": "10px",
      "margin-top": "16px",
      padding: "16px",
      display: "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "font-size": "14px",
      height: "60px",
      color: "#646473"
    }
  }
}));

let geocoder;
async function geocodeLatLng(lat, lng) {
  if (!geocoder) {
    geocoder = new window.google.maps.Geocoder();
  }
  return geocoder.geocode({ location: { lat, lng } });
}

const defaultLat = "25.0329636";
const defaultLng = "121.5654268";

function TranserModal({ open, onConfirm, onClose, addressData, CountryName }) {
  const { t } = useTranslation();
  const [state, setState] = useState(() => ({
    latitude: defaultLat,
    longitude: defaultLng,
    store_address: "",
    ...addressData
  }));

  const classes = useModalStyles();

  const handleConfirm = () => {
    return onConfirm(state);
  };
  const contextValue = useContext(LanguageContext);
  useEffect(() => {
    // let isMounted = true; // 创建一个标志，指示组件是否挂载
    // fetchBoundsByRegion(CountryName,isMounted);
    // 清理函数，设置标志为 false
    // return () => {
    //   isMounted = false
    // };
    // const latitude = addressData.lat ? addressData.lat : "31.217546";
    // const longitude = addressData.long ? addressData.long : "121.360375";
  }, [addressData, open, CountryName]);

  useEffect(() => {
    if (open) PlatFormLoading.show();
  }, [open]);

  // 地图初始化完成触发
  const HandleMapApiOnload = () => {
    PlatFormLoading.hide();
    console.log("-----------addressData-----", addressData);
    fetchBoundsByRegion(CountryName);
  };

  const isValidCoordinates = (lat, lng) => {
    return (
      !isNaN(lat) &&
      !isNaN(lng) &&
      lat >= -90 &&
      lat <= 90 &&
      lng >= -180 &&
      lng <= 180
    );
  };

  // 通过地区，查询地区中心经纬度
  const fetchBoundsByRegion = async region => {
    state.latitude = addressData.lat; // 纬度
    state.longitude = addressData.long; // 经度
    state.store_address = addressData.store_address; // 纬度
    if (addressData.lat && addressData.long) {
      // 经纬度传入错误，设置默认值
      if (isValidCoordinates(addressData.lat, addressData.long) === false) {
        console.log("经纬度传入错误，设置默认值");
        state.latitude = defaultLat;
        state.longitude = defaultLng;
      }
      setState({ ...state });
      return;
    }
    console.log("---------region-----", region);
    // 台湾 地区进行特殊处理
    if (region == "Taiwan") {
      state.latitude = defaultLat;
      state.longitude = defaultLng;
      setState({ ...state });
      return;
    }

    const apiKey = APP_ENV.REACT_APP_GOOGLE_MAP_API_KEY; // 确保你已经在环境变量中设置你的 API 密钥
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        region
      )}&key=${apiKey}`
    );

    if (!response.ok) {
      throw new Error("Unable to fetch bounds");
    }

    const data = await response.json();

    if (
      data.status === "OK" &&
      data.results &&
      data.results.length > 0 &&
      data.results[0]
    ) {
      const location = data.results[0].geometry.location;
      state.latitude = location.lat;
      state.longitude = location.lng;
      setState({
        ...state
      });
    } else {
      throw new Error("No results found");
    }
  };

  const handlePlaceSelect = place => {
    if (place?.geometry?.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setState({
        latitude: lat,
        longitude: lng,
        store_address: place.formatted_address || place.name
      });
    }
  };

  const handleMapClick = useCallback(async event => {
    try {
      const lat = event.detail.latLng.lat;
      const lng = event.detail.latLng.lng;
      const result = await geocodeLatLng(lat, lng);
      setState(prevState => ({
        ...prevState,
        latitude: lat,
        longitude: lng,
        store_address: result.results[0].formatted_address
      }));
      // event.map.setCenter(event.detail.latLng)
    } catch (e) {
      toast.error(`Geocoder failed due to: ${e}`);
    }
  }, []);

  return (
    <Modal
      title={t({ defaultMessage: "选择地址" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      className={classes.StoreEditMapModal}
      width={1000}
      height={600}
    >
      <div className={classes.StoreEditMapBox}>
        {
          // state.latitude && state.longitude && (
          <APIProvider
            key={contextValue.userLanguage}
            apiKey={APP_ENV.REACT_APP_GOOGLE_MAP_API_KEY}
            language={contextValue.userLanguage}
            onLoad={HandleMapApiOnload}
          >
            <div className={classes.mapSearchInput}>
              <GoogleMapAutoComplete onPlaceSelect={handlePlaceSelect} />
            </div>
            <Map
              className="platformMap"
              center={{
                lat: parseFloat(state.latitude),
                lng: parseFloat(state.longitude)
              }}
              defaultZoom={13}
              onClick={handleMapClick}
              onError={e => {
                console.log("地图加载失败", e);
              }}
            >
              <Marker
                position={{
                  lat: parseFloat(state.latitude),
                  lng: parseFloat(state.longitude)
                }}
              />
            </Map>
          </APIProvider>
          // )
        }
        <div className="map-detail">
          <div>
            {t({ defaultMessage: "详细地址" })}：{state.store_address}
          </div>
          <div>
            {t({ defaultMessage: "经纬度" })}：{state.longitude}
            {state.longitude ? "," : ""}
            {state.latitude}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(TranserModal);
